import { MenuProduct } from '../XV2';
import { ModifierGroupPresentationType } from '../XV2';
import sum from 'lodash/sum';
import { useActiveOrderManager } from './useActiveOrderManager';

export function useActiveZoneMenuProduct(menuProduct: MenuProduct) {
    const activeOrderManager = useActiveOrderManager();
    const priceInitial = activeOrderManager.getRegularOrTakeawayPrice(menuProduct);
    const priceWithServiceFee = getPriceWithServiceFee();
    const priceListItem = getListItemPrice();

    function getPriceWithServiceFee() {
        const priceWithDiscount = activeOrderManager.calculateProductDiscount(menuProduct.productId, priceInitial);

        if (activeOrderManager.isServiceFeeDisplayedInList && !activeOrderManager.hasServiceFeeConfig()) {
            return activeOrderManager.getPriceWithServiceFee(priceWithDiscount);
        } else {
            return priceWithDiscount;
        }
    }

    function getListItemPrice() {
        let price = 0;

        const productModifierGroup = menuProduct.product?.productModifierGroups?.find(
            (item) => item.modifierGroup.presentationType === ModifierGroupPresentationType.PACKAGE,
        );

        if (productModifierGroup) {
            const prices = productModifierGroup?.modifierGroup?.modifierGroupItems.map((item) => item.price) || [];
            price = sum(prices) || 0;
        }

        return priceWithServiceFee + price;
    }

    return {
        isDiscounted: priceWithServiceFee < priceInitial,
        priceWithoutDiscount: priceInitial + activeOrderManager.getServiceFee(),
        isFree: priceListItem === 0,
        getListItemPrice() {
            return priceListItem;
        },
        calculateActiveOrderProductPrice: activeOrderManager.calculateActiveOrderProductPrice,
    };
}
